module.exports = __webpack_public_path__ + "static/media/ranking.70ce0178.svg";